import { render, staticRenderFns } from "./upload-modal.vue?vue&type=template&id=4d81a08c&scoped=true"
import script from "./upload-modal.vue?vue&type=script&lang=js"
export * from "./upload-modal.vue?vue&type=script&lang=js"
import style0 from "./upload-modal.vue?vue&type=style&index=0&id=4d81a08c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d81a08c",
  null
  
)

export default component.exports